import { all } from 'redux-saga/effects';
import ProfileSagas from './profile.sagas';
import ReloadSagas from './reload.sagas';
import InitialReloadSagas from './initialReload.sagas';
import ReloadWithLocSagas from './reloadWithLoc.sagas';

export default function* rootSaga() {
  yield all([...ProfileSagas, ...ReloadSagas, ...InitialReloadSagas, ...ReloadWithLocSagas]);
}
